import logging from '@wr/logging';
import {getErrorStatusCode} from '../components/pages/PoliStatusWaiting/helpers';
import config from '../config';
import eventIds from '../event-ids';
import {throwOnResponseError} from '../utils/createResponseError';
import {getPaymentSessionId} from '../utils/helpers';

const getTabapayStatus = async ({
    requestId,
    sessionId,
    params,
    query
}) => {
    const logger = logging.createLogger(config.app.name, config.logger.logServerUrl);
    const paymentSessionId = getPaymentSessionId(params, query);
    const loggerProps = {
        requestId, sessionId, paymentSessionId
    };

    logger.info('Retrieving Tabapay status', {
        eventId: eventIds['Retrieving Tabapay status'],
        ...loggerProps
    });

    try {
        const url = new URL(`/api/sessions/${paymentSessionId}`, config.tabapayIntegrator.url);

        const statusResult = await fetch(url.toString());

        throwOnResponseError(statusResult);

        const statusData = await statusResult.json();

        logger.info('Retrieved Tabapay status', {
            eventId: eventIds['Retrieved Tabapay status'],
            ...loggerProps,
            payload: statusData
        });

        return statusData;
    } catch (e) {
        const error = new Error(`Error retrieving Tabapay status: ${e.message}`);

        error.status = getErrorStatusCode(e);

        logger.error(error.message, {
            eventId: eventIds['Error retrieving Tabapay status'],
            ...loggerProps
        });

        throw error;
    }
};

export default getTabapayStatus;
